import { render } from "./CirclesGraphic.vue?vue&type=template&id=2255de9e&scoped=true&ts=true"
import script from "./CirclesGraphic.vue?vue&type=script&lang=ts"
export * from "./CirclesGraphic.vue?vue&type=script&lang=ts"

import "./CirclesGraphic.vue?vue&type=style&index=0&id=2255de9e&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2255de9e"]])

export default __exports__